import { Module } from "vuex";

import { UserState } from "./types";

import { actionNames, actions } from "./actions";
import { RootState } from "../../types";
import { mutationNames, mutations } from "./mutations";
import { getterNames, getters } from "./getters";
import firebase from "firebase/app";

export const api = {
  namespace: "user",
  getters: getterNames,
  mutations: mutationNames,
  actions: actionNames,
  state: {
    user: "user",
  },
};

export function userId(_rootGetters: any) {
  return firebase.auth().currentUser?.uid || null;
  // return rootGetters[gettersNs(api, api.getters.getUserId)] as string;
}

const module: Module<UserState, RootState> = {
  namespaced: true,
  state: () => new UserState(),
  actions,
  mutations,
  getters,
};

export default module;
